import { DeleteFilled, EditOutlined, SaveOutlined } from '@ant-design/icons'
import { FormInput } from '@components/_SiteWide/Form/FormInput'
import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { ErrorNotification } from '@gravitate-js/excalibrr'
import api from '@utils/api'
import { Col, Form, Popconfirm, Row, Tooltip } from 'antd'
import React, { useState } from 'react'

import { BlendComponentPercentage } from './ComponentFormList'

export function BlendForms({ products, editable, setEditMode, selectedProduct, updateRow }) {
  return (
    <Row>
      {selectedProduct.blends.map((blend, i) => (
        <Col key={i} span={12}>
          <BlendForm
            index={i}
            blend={blend}
            products={products}
            editable={editable}
            setEditMode={setEditMode}
            selectedProduct={selectedProduct}
            updateRow={updateRow}
          />
        </Col>
      ))}
    </Row>
  )
}

function BlendForm({ index, products, editable, setEditMode, blend, selectedProduct, updateRow }) {
  const { scopes } = useSecurityContext()
  const canEditBlends = scopes.admin?.site_write
  const [blendEditing, setBlendEditing] = useState(editable || !blend.name)
  const [form] = Form.useForm()
  form.setFieldsValue({ ...blend, name: blend.name || `Blend ${index + 1}` })

  const toggleEditing = () => {
    setBlendEditing(!blendEditing)
    setEditMode(!editable)
  }

  const updateProduct = (blend, formData) => {
    const updatedData = {
      old_name: blend.name,
      name: formData.name,
      components: formData.components,
    }
    api.updateBlend(selectedProduct.id, updatedData).then(() => {
      Object.assign(blend, updatedData)
      updateRow(selectedProduct)
    })

    toggleEditing()
  }
  return (
    <Form
      form={form}
      id={`blendForm${index}`}
      size='small'
      onFinish={(formData) => {
        updateProduct(blend, formData)
      }}
      onFinishFailed={ErrorNotification}
    >
      <Row className='blend-control-row'>
        <Col className='blend-control-col' span={12}>
          <Row>
            <Col className={`blend-name${!blendEditing ? ' display' : ''}`} span={18}>
              <FormInput
                initialValue={blend.name}
                editable={blendEditing}
                name='name'
                width='100%'
                required
                message='Blend Name is required'
                placeholder='Blend Name'
              />
            </Col>
            {canEditBlends && (
              <Col align='right' span={6} className={`${!editable ? 'mt-1' : ''}`}>
                <Tooltip mouseEnterDelay={2} title={`Click here to ${editable ? 'save' : 'edit'} this Blend`}>
                  <span>
                    {blendEditing && (
                      <SaveOutlined
                        className='save-blend'
                        onClick={(e) => {
                          e.preventDefault()
                          form.submit()
                        }}
                      />
                    )}
                    {!blendEditing && (
                      <EditOutlined
                        className='edit-blend'
                        onClick={() => {
                          if (!editable) toggleEditing()
                        }}
                      />
                    )}
                  </span>
                </Tooltip>
                <Tooltip mouseEnterDelay={2} title='Click here to delete this Blend'>
                  <Popconfirm
                    title='Are you sure you want to delete this Blend?'
                    onConfirm={(e) => {
                      e.preventDefault()
                      api.deleteBlend(selectedProduct.id, blend.name).then(() => {
                        const remainingBlends = selectedProduct.blends.filter((item) => item.name !== blend.name)
                        updateRow({ ...selectedProduct, blends: remainingBlends })
                      })
                    }}
                    okText='Yes'
                    cancelText='No'
                  >
                    <DeleteFilled className='delete-blend' />
                  </Popconfirm>
                </Tooltip>
              </Col>
            )}
          </Row>
        </Col>

        <Col span={12}>
          <BlendComponentPercentage
            components={blend.components}
            products={products}
            editable={blendEditing}
            canEditBlends={canEditBlends}
          />
        </Col>
      </Row>
    </Form>
  )
}
